export default __webpack_public_path__ + "static/media/icon-transportation.2851bf53.png";